import {Grid, Stack, Typography} from "@mui/material";
import React from "react";

const CustomAgenda = ({agendaId, logistics}) => {
  const agenda = agendas[agendaId]
  return (agenda && <Stack>
      <Typography component='div'>
        {agenda.sede}
      </Typography>
      <Stack mt={2} direction={"row"} spacing={0.5}>
        <Typography color={'primary'} fontWeight={'bold'}>{agenda.title}</Typography>
        <Typography color={'primary'} fontWeight={'bold'}>AGENDA</Typography>
      </Stack>
      {agenda.data.map((data, i) => (
        <Grid key={i} mt={1} container>
          <Grid item xs={6} sm={2}>
            <Typography fontWeight={'bold'}>
              {data.time}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={10}>
            {data.event}
          </Grid>
        </Grid>

      ))}
      {!logistics && <Typography>
        <br/>
        <u>
          * Gli orari indicati potrebbero subire variazioni. L'agenda definitiva ti sarà inviata via email in prossimità dell'evento.
        </u>
      </Typography>}
    </Stack>
  );
}

export default CustomAgenda

const agendas = {
  agendaRoma: {
    title: "30 SETTEMBRE · ",
    sede: <>Sede dell'evento: <b>A.Roma Lifestyle Hotel</b> - (Via Giorgio Zoega, 60, 00164 Roma RM - c/o Centro Congressi)</>,
    data: [
      {time: "ore 12:00", event: "Accredito"},
      {time: "ore 12:30", event: "Light lunch"},
      {time: "ore 14:00", event: "Apertura Lavori"},
      {time: "ore 17:15", event: "Chiusura Lavori"},
    ]
  },
  agendaMilano: {
    title: "5 OTTOBRE · ",
    sede: <>Sede dell'evento: <b>Sheraton Milan San Siro</b> (Via Caldera, 3, 20153 Milano MI)</>,
    data: [
      {time: "ore 12:00", event: "Accredito"},
      {time: "ore 12:30", event: "Light Lunch"},
      {time: "ore 14:00", event: "Apertura Lavori"},
      {time: "ore 17:15", event: "Chiusura Lavori"},
    ]
  }
}